export default "__VITE_PUBLIC_ASSET__4579c869__"